import type { ManagementAppRouter } from "@daytrip/api";
import { ENVIRONMENT } from "@daytrip/legacy-config";
import { createTRPCClient, httpLink, loggerLink } from "@trpc/client";
import superjson from "superjson";

import { API_TRPC_URL } from "../../config.management";
import { getManagementRefreshToken } from "../../utils/authentication/authenticationUtils";

export const apiTrpcRefreshTokenClient = createTRPCClient<ManagementAppRouter>({
    links: [
        loggerLink({
            enabled: () => ENVIRONMENT !== "production",
        }),
        httpLink({
            url: API_TRPC_URL,
            transformer: superjson,
            headers() {
                return {
                    Authorization: `Bearer ${getManagementRefreshToken()}`,
                };
            },
        }),
    ],
});
